// import React from "react";
import { Route, Routes } from "react-router-dom";

import Navbar from "../../../../default-components/Navbar";
import Footer from "../../../../default-components/Footer";
import GlobalRoute from "../../../../global route/GlobalRoute";
import ColorsComponent from "../../../../default-components/ColorsComponent";

import PGSecurityOneHome from "../securityOnePages/PGSecurityOneHome";
import FooterUpper from "../../../../default-components/FooterUpper";
import PGDashboard from "../../../../allRoles/dashboards/PGDashboard";
import SecurityOneHostHome from "../securityOneComponent/SecurityOneHostHome";
import PGVisitors from "../securityOnePages/PGVisitors";
import SecurityOneHostPreApprove from "../securityOneComponent/SecurityOneHostPreApprove";
import PGSecurityOneVisitorLogs from "../securityOnePages/PGSecurityOneVisitorLogs";
import SecurityOneVisitorService from "../securityOneComponent/SecurityOneVisitorService";
import PGSecurityOneVisitorDetails from "../securityOnePages/PGSecurityOneVisitorDetails";
import SecurityOneVisitorAttendance from "../securityOneComponent/SecurityOneVisitorAttendace";

const SecurityOneRoute = () => {
  return (
    <div>
      <div className="security_one_route_parent">
        <Navbar />
        <Routes>
          <Route path="/" element={<PGSecurityOneHome />} />
          <Route path="/dashboard" element={<PGDashboard />}></Route>
          <Route path="/host-home" element={<SecurityOneHostHome />}></Route>
          <Route
            path="/host-pre-approve"
            element={<SecurityOneHostPreApprove />}
          ></Route>
          <Route path="/visitors-type" element={<PGVisitors />} />
          <Route
            path="/visitor-log/:id"
            element={<PGSecurityOneVisitorLogs />}
          />
          <Route
            path="/visitor-details/:id"
            element={<PGSecurityOneVisitorDetails />}
          />
          <Route
            path="/service-visitor"
            element={<SecurityOneVisitorService />}
          />
          <Route
            path="/service-attendance"
            element={<SecurityOneVisitorAttendance />}
          />
        </Routes>
        <GlobalRoute />
        <ColorsComponent />
        <FooterUpper />
        <Footer />
      </div>
    </div>
  );
};

export default SecurityOneRoute;
